var publicPath = __webpack_public_path__;
                    var symbolUrl = 'sprites.svg#icon-ic_clock';
                    var viewUrl = 'sprites.svg#view-icon-ic_clock';

                    

                    module.exports = {
                        url: publicPath + symbolUrl,
                        view: publicPath + viewUrl,
                        viewBox: '0 0 20 20',
                        title: '',
                        toString: function () {
                            return JSON.stringify(this.view);
                        }
                    };